import * as React from "react";
import { getAuth } from "firebase/auth";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import Link from "@mui/material/Link";
import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Tooltip from "@mui/material/Tooltip";
import Toolbar from "@mui/material/Toolbar";
import AdbIcon from "@mui/icons-material/Adb";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import WidgetsIcon from "@mui/icons-material/Widgets";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { UserRoles } from "../employee-page/user-roles.enum";

const settings = ["Вийти з акаунту"];

const InvetAppBar = ({ authScope }) => {
	const [anchorElNav, setAnchorElNav] = React.useState(null);
	const [anchorElUser, setAnchorElUser] = React.useState(null);

	const handleOpenNavMenu = (event) => {
		setAnchorElNav(event.currentTarget);
	};
	const handleOpenUserMenu = (event) => {
		setAnchorElUser(event.currentTarget);
	};

	const handleCloseNavMenu = () => {
		setAnchorElNav(null);
	};

	const handleCloseUserMenu = () => {
		setAnchorElUser(null);
	};

	const handleLogOutClick = () => {
		return getAuth().signOut();
	};

	const Search = styled("div")(({ theme }) => ({
		position: "relative",
		borderRadius: theme.shape.borderRadius,
		backgroundColor: alpha(theme.palette.common.white, 0.15),
		"&:hover": {
			backgroundColor: alpha(theme.palette.common.white, 0.25),
		},
		marginLeft: 0,
		width: "100%",
		[theme.breakpoints.up("sm")]: {
			marginLeft: theme.spacing(1),
			width: "auto",
		},
	}));

	const SearchIconWrapper = styled("div")(({ theme }) => ({
		padding: theme.spacing(0, 2),
		height: "100%",
		position: "absolute",
		pointerEvents: "none",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	}));

	const StyledInputBase = styled(InputBase)(({ theme }) => ({
		color: "inherit",
		"& .MuiInputBase-input": {
			padding: theme.spacing(1, 1, 1, 0),
			// vertical padding + font size from searchIcon
			paddingLeft: `calc(1em + ${theme.spacing(4)})`,
			transition: theme.transitions.create("width"),
			width: "100%",
			[theme.breakpoints.up("sm")]: {
				width: "12ch",
				"&:focus": {
					width: "22ch",
				},
			},
		},
	}));

	return (
		<AppBar position="static">
			<Container maxWidth="xl">
				<Toolbar disableGutters>
					{/* <AdbIcon sx={{ display: { xs: "none", md: "flex" }, mr: 1 }} /> */}
					<Typography
						variant="h6"
						noWrap
						component="a"
						href="/"
						sx={{
							mr: 2,
							display: { xs: "none", md: "flex" },
							fontFamily: "monospace",
							fontWeight: 700,
							letterSpacing: ".3rem",
							color: "inherit",
							textDecoration: "none",
						}}
					>
						INVET
					</Typography>

					<Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
						<IconButton
							size="large"
							aria-label="account of current user"
							aria-controls="menu-appbar"
							aria-haspopup="true"
							onClick={handleOpenNavMenu}
							color="inherit"
						>
							<MenuIcon />
						</IconButton>
						<Menu
							id="menu-appbar"
							anchorEl={anchorElNav}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "left",
							}}
							keepMounted
							transformOrigin={{
								vertical: "top",
								horizontal: "left",
							}}
							open={Boolean(anchorElNav)}
							onClose={handleCloseNavMenu}
							sx={{
								display: { xs: "block", md: "none" },
							}}
						>
							{/* mobile navbar */}
							{authScope === UserRoles.ADMIN && (
								<MenuItem key="employee" onClick={handleCloseNavMenu}>
									<Link href="/employee">
										<PersonOutlineIcon style={{ color: "black" }} />
									</Link>
								</MenuItem>
							)}
							{(authScope === UserRoles.MANAGER ||
								authScope === UserRoles.ADMIN) && (
								<MenuItem key="orders" onClick={handleCloseNavMenu}>
									<Link href="/orders">
										<WidgetsIcon style={{ color: "black" }} />
									</Link>
								</MenuItem>
							)}
							{authScope === UserRoles.ADMIN && (
								<MenuItem key="warehouses" onClick={handleCloseNavMenu}>
									<Link href="/warehouses">
										<WarehouseIcon style={{ color: "black" }} />
									</Link>
								</MenuItem>
							)}
							{(authScope === UserRoles.MANAGER ||
								authScope === UserRoles.ADMIN) && (
								<MenuItem key="map" onClick={handleCloseNavMenu}>
									<Link href="/map">
										<MapOutlinedIcon style={{ color: "black" }} />
									</Link>
								</MenuItem>
							)}
							{authScope === UserRoles.ADMIN && (
								<MenuItem key="vans" onClick={handleCloseNavMenu}>
									<Link href="/vans">
										<LocalShippingIcon style={{ color: "black" }} />
									</Link>
								</MenuItem>
							)}

							{/* <MenuItem key="orders" onClick={handleCloseNavMenu}>
								<Link href="/orders">
									<WidgetsIcon color="error" />
								</Link>
							</MenuItem>
							<MenuItem key="warehouses" onClick={handleCloseNavMenu}>
								<Link href="/warehouses">
									<WarehouseIcon color="error" />
								</Link>
							</MenuItem>
							<MenuItem key="map" onClick={handleCloseNavMenu}>
								<Link href="/map">
									<MapOutlinedIcon color="error" />
								</Link>
							</MenuItem>
							<MenuItem key="vans" onClick={handleCloseNavMenu}>
								<Link href="/vans">
									<LocalShippingIcon style={{ color: "error" }} />
								</Link>
							</MenuItem> */}
						</Menu>
					</Box>
					{/* <AdbIcon sx={{ display: { xs: "flex", md: "none" }, mr: 1 }} /> */}
					<Typography
						variant="h5"
						noWrap
						component="a"
						href=""
						sx={{
							mr: 2,
							display: { xs: "flex", md: "none" },
							flexGrow: 1,
							fontFamily: "monospace",
							fontWeight: 700,
							letterSpacing: ".3rem",
							color: "inherit",
							textDecoration: "none",
						}}
					>
						INVET
					</Typography>
					<Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
						{/* <Search>
							<SearchIconWrapper>
								<SearchIcon />
							</SearchIconWrapper>
							<StyledInputBase
								placeholder="Search…"
								inputProps={{ "aria-label": "search" }}
							/>
						</Search> */}
					</Box>
					{/* main navbar */}
					<Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
						{authScope === UserRoles.ADMIN && (
							<MenuItem key="employee" onClick={handleCloseNavMenu}>
								<Link href="/employee">
									<PersonOutlineIcon style={{ color: "black" }} />
								</Link>
							</MenuItem>
						)}
						{(authScope === UserRoles.MANAGER ||
							authScope === UserRoles.ADMIN) && (
							<MenuItem key="orders" onClick={handleCloseNavMenu}>
								<Link href="/orders">
									<WidgetsIcon style={{ color: "black" }} />
								</Link>
							</MenuItem>
						)}
						{authScope === UserRoles.ADMIN && (
							<MenuItem key="warehouses" onClick={handleCloseNavMenu}>
								<Link href="/warehouses">
									<WarehouseIcon style={{ color: "black" }} />
								</Link>
							</MenuItem>
						)}
						{(authScope === UserRoles.MANAGER ||
							authScope === UserRoles.ADMIN) && (
							<MenuItem key="map" onClick={handleCloseNavMenu}>
								<Link href="/map">
									<MapOutlinedIcon style={{ color: "black" }} />
								</Link>
							</MenuItem>
						)}
						{authScope === UserRoles.ADMIN && (
							<MenuItem key="vans" onClick={handleCloseNavMenu}>
								<Link href="/vans">
									<LocalShippingIcon style={{ color: "black" }} />
								</Link>
							</MenuItem>
						)}
					</Box>

					<Box sx={{ flexGrow: 0 }}>
						<Tooltip title="Відкрити налаштування">
							<IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
								<AccountCircleIcon />
							</IconButton>
						</Tooltip>
						<Menu
							sx={{ mt: "45px" }}
							id="menu-appbar"
							anchorEl={anchorElUser}
							anchorOrigin={{
								vertical: "top",
								horizontal: "right",
							}}
							keepMounted
							transformOrigin={{
								vertical: "top",
								horizontal: "right",
							}}
							open={Boolean(anchorElUser)}
							onClose={handleCloseUserMenu}
						>
							{settings.map((setting) => (
								<MenuItem key={setting} onClick={handleLogOutClick}>
									<Typography textAlign="center">{setting}</Typography>
								</MenuItem>
							))}
						</Menu>
					</Box>
				</Toolbar>
			</Container>
		</AppBar>
	);
};
export default InvetAppBar;
